import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";

/** @jsxImportSource @emotion/react */
import { Typography } from "@vc-workspace/utils-typography";
import { containerStyles, contentGridContainer, contentGridItemContainer, contentGridItemImage } from './maker-vibecity-pricing.module.style';
export function MakerVibecityPricing(props) {
  return _jsxs("div", {
    css: containerStyles,
    children: [_jsxs(Typography, {
      type: props.context.isMobileView ? "Headline_H1" : "Heading2",
      color: "night_rider",
      className: "text-center",
      bold: true,
      children: ["Simple, Transparent Pricing ", props.context.isMobileView ? _jsx("br", {}) : null, "designed to help your grow"]
    }), _jsx("div", {
      className: "page-container",
      children: _jsxs("div", {
        css: contentGridContainer,
        children: [_jsxs("div", {
          css: contentGridItemContainer,
          children: [_jsxs("picture", {
            children: [_jsx("source", {
              srcSet: "/_mp-images/processing_fee".concat(props.context.isMobileView ? "_mobile" : "", ".webp"),
              type: "image/webp"
            }), _jsx("img", {
              src: "/_mp-images/processing_fee".concat(props.context.isMobileView ? "_mobile" : "", ".png"),
              css: contentGridItemImage
            })]
          }), _jsxs("div", {
            className: props.context.isMobileView ? "pl-6" : "",
            children: [_jsx(Typography, {
              type: props.context.isMobileView ? "Headline_H3" : "Headline_H1",
              color: "heavy_metal",
              className: props.context.isMobileView ? "" : "pt-4",
              bold: true,
              children: "Zero Listing Fee"
            }), _jsx(Typography, {
              type: props.context.isMobileView ? "Body1" : "Headline_H3",
              color: "night_rider",
              className: props.context.isMobileView ? "pt-1" : "pt-4",
              children: "No fees for listing your products. List as many products as you like!"
            })]
          })]
        }), _jsxs("div", {
          css: contentGridItemContainer,
          children: [_jsxs("picture", {
            children: [_jsx("source", {
              srcSet: "/_mp-images/nominal_commission".concat(props.context.isMobileView ? "_mobile" : "", ".webp"),
              type: "image/webp"
            }), _jsx("img", {
              src: "/_mp-images/nominal_commission".concat(props.context.isMobileView ? "_mobile" : "", ".png"),
              css: contentGridItemImage
            })]
          }), _jsxs("div", {
            className: props.context.isMobileView ? "pl-6" : "",
            children: [_jsx(Typography, {
              type: props.context.isMobileView ? "Headline_H3" : "Headline_H1",
              color: "heavy_metal",
              className: props.context.isMobileView ? "" : "pt-4",
              bold: true,
              children: "Nominal Commissions"
            }), _jsx(Typography, {
              type: props.context.isMobileView ? "Body1" : "Headline_H3",
              color: "night_rider",
              className: props.context.isMobileView ? "pt-1" : "pt-4",
              children: "Only 3% commission for orders from your existing customers, 15% commission when we get you a new customer from VibeCity marketplace"
            })]
          })]
        }), _jsxs("div", {
          css: contentGridItemContainer,
          children: [_jsxs("picture", {
            children: [_jsx("source", {
              srcSet: "/_mp-images/flat_shipping".concat(props.context.isMobileView ? "_mobile" : "", ".webp"),
              type: "image/webp"
            }), _jsx("img", {
              src: "/_mp-images/flat_shipping".concat(props.context.isMobileView ? "_mobile" : "", ".png"),
              css: contentGridItemImage
            })]
          }), _jsxs("div", {
            className: props.context.isMobileView ? "pl-6" : "",
            children: [_jsx(Typography, {
              type: props.context.isMobileView ? "Headline_H3" : "Headline_H1",
              color: "heavy_metal",
              className: props.context.isMobileView ? "" : "pt-4",
              bold: true,
              children: "Best Shipping Rates"
            }), _jsx(Typography, {
              type: props.context.isMobileView ? "Body1" : "Headline_H3",
              color: "night_rider",
              className: props.context.isMobileView ? "pt-1" : "pt-4",
              children: "Pay best shipping charges. Ship in 2 taps. No hassle of finding & haggling with couriers!"
            })]
          })]
        })]
      })
    })]
  });
}
export default MakerVibecityPricing;